<template>
  <a-spin :spinning="confirmLoading">
    <div class="driver-form-box" :class="disabled?'disabled-form':'no-disabled-form'" :style="{height:(height-subHeight)+'px'}">
      <div class="driver-form-box-left">
         <j-form-container >
        <a-form :form="form" slot="detail">
          <div class="driver-new-box" :style="{height:(height-subHeight)+'px'}">
          <div class="driver-new-box-right" ref="scrollRight"  :style="{height:(height-subHeight-24)+'px'}">
            <div class="driver-new-box-item" v-if="model.id">
              <div class="driver-label-title font-16">挂靠平台</div>
              <div class="driver-value-ipt">
                <a-form-item label="" :labelCol="labelCol"  :wrapperCol="wrapperCol" >
                  <j-search-select-tag
                    :disabled="true"
                    style="width: 100%"
                    placeholder="请选择挂靠平台"
                    v-decorator="['platformId', validatorRules.platformId]"
                    :dictOptions="platformList">
                  </j-search-select-tag>
                </a-form-item>
              </div>
            </div>
            <div class="driver-new-box-item" v-else>
              <div class="driver-label-title font-16">挂靠平台</div>
              <div class="driver-value-ipt">
            <a-form-item label="" :labelCol="labelCol"  :wrapperCol="wrapperCol">
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择挂靠平台"
                style="width: 100%"
                v-decorator="['platformId', validatorRules.platformId]"
                :dictOptions="platformList">
              </j-search-select-tag>
            </a-form-item>
              </div>
            </div>
            <div class="driver-new-box-item">
              <div class="driver-label-title font-16">当前状态</div>
              <div class="driver-value-ipt">
            <a-form-item  label="" :labelCol="labelCol"  :wrapperCol="wrapperCol">
              <j-dict-select-tag :disabled="disabled"  style="width: 100%" type="list" v-decorator="['currentStatus', validatorRules.currentStatus]" :trigger-change="true" dictCode="current_status" placeholder="请选择当前状态" />
            </a-form-item>
              </div>
            </div>
            <div class="driver-new-box-item">
              <div class="driver-label-title font-16">识别号</div>
              <div class="driver-value-ipt">
            <a-form-item  label="" :labelCol="labelCol"  :wrapperCol="wrapperCol">
              <a-input :disabled="disabled" style="width: 100%" v-decorator="['identificationNumber', validatorRules.identificationNumber]" placeholder="请输入识别号"  ></a-input>
            </a-form-item>
              </div>
            </div>
            <div class="driver-new-box-item">
              <div class="driver-label-title font-16">所属车队</div>
              <div class="driver-value-ipt">
                <a-form-item  label="" :labelCol="labelCol"  :wrapperCol="wrapperCol">
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择所属车队"
                style="width: 100%"
                v-decorator="['teamId', validatorRules.teamId]"
                :dictOptions="teamList">
              </j-search-select-tag>
            </a-form-item>
              </div>
            </div>
            <div class="driver-new-box-item" v-if="checkHasPer('edit:platformNo')">
              <div class="driver-label-title font-16">所属队长</div>
              <div class="driver-value-ipt">
                <a-form-item  label="" :labelCol="labelCol"  :wrapperCol="wrapperCol">
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择所属队长"
                style="width: 100%"
                v-decorator="['leaderId', validatorRules.leaderId]"
                :dictOptions="userList">
              </j-search-select-tag>
            </a-form-item>
              </div>
            </div>
            <div class="driver-new-box-item" v-else-if="model.id">
              <div class="driver-label-title font-16">所属队长</div>
              <div class="driver-value-ipt">
                <a-form-item  label="" :labelCol="labelCol"  :wrapperCol="wrapperCol">
              <j-search-select-tag
                :disabled="true"
                placeholder="请选择所属队长"
                style="width: 100%"
                v-decorator="['leaderId', validatorRules.leaderId]"
                :dictOptions="userList">
              </j-search-select-tag>
            </a-form-item>
              </div>
            </div>
            <div class="driver-new-box-item" v-else>
              <div class="driver-label-title font-16">所属队长</div>
              <div class="driver-value-ipt">
                <a-form-item  label="" :labelCol="labelCol"  :wrapperCol="wrapperCol">
              <j-search-select-tag
                :disabled="disabled"
                style="width: 100%"
                placeholder="请选择所属队长"
                v-decorator="['leaderId', validatorRules.leaderId]"
                :dictOptions="userList">
              </j-search-select-tag>
            </a-form-item>
              </div>
            </div>
            <div class="driver-new-box-item">
              <div class="driver-label-title font-16">首次注册时间</div>
              <div class="driver-value-ipt">
                <a-form-item  label="" :labelCol="labelCol"  :wrapperCol="wrapperCol">
              <j-date :disabled="disabled"   placeholder="请选择首次注册时间" v-decorator="['regTime', validatorRules.regTime]" :trigger-change="true" style="width: 100%" />
            </a-form-item>
              </div>
            </div>
            <div class="driver-new-box-item">
              <div class="driver-label-title font-16">备注</div>
              <div class="driver-value-ipt">
                <a-form-item  label="" :labelCol="labelCol"  :wrapperCol="wrapperCol">
          <a-textarea :disabled="disabled"  style="width: 100%"  v-decorator="['remark', validatorRules.remark]"  :rows="5"  placeholder="请输入备注"  ></a-textarea>
          </a-form-item>
              </div>
            </div>
          </div>
          </div>
      </a-form>
    </j-form-container>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { PlatformFormMixins } from '@/mixins/dm5/driver/PlatformFormMixins'
  export default {
    name: 'DmPlatformForm',
    inject:["closeCurrent"],
    mixins: [PlatformFormMixins],
    components: {
    },

  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
@import '~@assets/less/dm/form.less';
@import '~@assets/less/dm5/driver/driverForm.less';
.driver-new-box-item{
  width: 80%;
}
</style>